import { ScrollArea } from '@/components/ui/scroll-area';
import { Calendar, ExternalLink } from 'lucide-react';

const EventsSection = ({ events }) => {
  return (
    <div className="content-card" data-testid="events-section">
      <div className="card-header">
        <h2>
          <Calendar size={20} className="inline" /> Local Events
        </h2>
      </div>
      <ScrollArea className="card-content">
        {events.length > 0 ? (
          <div className="events-list">
            {events.map((event, index) => (
              <div key={event.link || `${event.title}-${event.date}`} className="event-item" data-testid={`event-item-${index}`}>
                <h3 className="event-title">{event.title}</h3>
                {event.date && <p className="event-date">{event.date}</p>}
                {event.description && <p className="event-desc">{event.description}</p>}
                {event.link && (
                  <a 
                    href={event.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="event-link"
                    data-testid={`event-link-${index}`}
                  >
                    More info <ExternalLink size={14} />
                  </a>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">No events available</p>
        )}
      </ScrollArea>
    </div>
  );
};

export default EventsSection;